import { render, staticRenderFns } from "./PurchaseOrderAttachments.vue?vue&type=template&id=1384a348"
import script from "./PurchaseOrderAttachments.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseOrderAttachments.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports